import React, { useState, useEffect } from 'react';
import Loading from '@tencent/dui/lib/components/Loading';
import style from './style.less';
import i18n from '@i18next/i18n';
import shareIcon from '@tencent/docs-design-resources/pc/png@2x/ist_PC_blankpage_Sharelink@2x.png';
import Button from '@tencent/dui/lib/components/Button';
import { qqQRCodeManager, wxQRCodeManager } from './qrcode';
import QRCodeMask from './qrcode-mask';

export enum QrCodeType {
    qq = 'qq',
    wx = 'wx',
}
interface Props {
    url: string;
    qrCodeType: QrCodeType;
    // 二维码是否扫描成功，pc 端可以进入演示了
    scanCompleted?: boolean;
    onPlay: () => void;
    onCreateRoom: () => void;
    onCloseRoom: () => void;
    onClose: () => void;
}

const enum QRCodeState {
    success = 'success',
    error = 'error',
    loading = 'loading',
}
interface QRCode {
    url: string;
    state: QRCodeState
}

const MobileRemoteControlInfo = (props: Props) => {
    const [qrCode, setQRCode] = useState<QRCode>({ url: '', state: QRCodeState.loading });
    const { url, qrCodeType, scanCompleted = false, onPlay, onCreateRoom, onCloseRoom, onClose } = props;
    const isReady = !!url;
    useEffect(() => {
        updateQRCodeInfo();
    }, [url]);

    const qrCodeManager = (qrCodeType === QrCodeType.qq) ? qqQRCodeManager : wxQRCodeManager;

    const updateQRCodeInfo = () => {
        if (!url) {
            setQRCode({
                url: '',
                state: QRCodeState.loading,
            });
            return;
        }
        if (qrCode.state === QRCodeState.error) {
            setQRCode({
                url: '',
                state: QRCodeState.loading,
            });
        }
        qrCodeManager.createQRCode(url)
            .then((qrCodeUrl) => {
                setQRCode({
                    url: qrCodeUrl,
                    state: QRCodeState.success,
                });
            })
            .catch(() => {
                setQRCode({
                    url: '',
                    state: QRCodeState.error,
                });
            });
    };

    const handleImageLoadError = () => {
        // 小程序图片加载失败后清除缓存并变为错误状态
        qrCodeManager.clearCache();
        setQRCode({
            url: '',
            state: QRCodeState.error,
        });
    };
    return (
        <div className={style['mobile-control-dialog']}>
            <span className={style['dialog-close']} onClick={onClose} />
            <div className={style['dialog-content']}>
                <div className={style['dialog-title']}>
                    {i18n.t('欢迎使用手机遥控提词')}
                </div>
                {
                    isReady ? (
                        <>
                            <div className={style['dialog-info-text']}>
                                {qrCodeType === QrCodeType.qq ? i18n.t('使用手机 QQ 扫描下方小程序码') : i18n.t('使用手机微信扫描下方小程序码')}
                            </div>
                            {
                                scanCompleted ? (
                                    <div className={style.qrcode}>
                                        <QRCodeMask
                                            onClick={onPlay}
                                            type='success'
                                            title={i18n.t('扫描成功')}
                                            text={i18n.t('点击开始演示')}
                                        ></QRCodeMask>
                                    </div>
                                ) : (
                                    <Loading visible={qrCode.state === QRCodeState.loading} tip={i18n.t('小程序码生成中')}>
                                        <div className={style.qrcode}>
                                            {
                                                qrCode.state === QRCodeState.error && (
                                                    <QRCodeMask
                                                        onClick={updateQRCodeInfo}
                                                        type='error'
                                                        title={i18n.t('小程序码生成失败')}
                                                        text={i18n.t('请点击重试')}
                                                    ></QRCodeMask>
                                                )
                                            }
                                            {
                                                qrCode.state === QRCodeState.success && (
                                                    <img src={qrCode.url} alt={i18n.t('手机遥控提词')} onError={handleImageLoadError} />
                                                )
                                            }
                                        </div>
                                    </Loading>
                                )
                            }
                            <div className={style['dialog-info-text']}>
                                {i18n.t('手机电脑同步控制，查看备注更加高效')}
                            </div>
                            {
                                scanCompleted ? (
                                    <Button className={style['blue-button']} type="primary" size="large" onClick={onPlay}>{i18n.t('开始演示')}</Button>
                                ) : (
                                    <Button className={style['white-button']} type="default" size="large" onClick={onCloseRoom}>{i18n.t('关闭提词器')}</Button>
                                )
                            }
                        </>
                    ) : (
                        <>
                            <div className={style['dialog-info-text']}>
                                {i18n.t('手机电脑同步控制，查看备注更加高效')}
                            </div>
                            <div className={style.qrcode}>
                                <img src={shareIcon} alt={i18n.t('手机遥控提词')} />
                            </div>
                            <Button className={style['blue-button']} type="primary" size="large" onClick={onCreateRoom}>{i18n.t('打开提词器')}</Button>
                        </>
                    )
                }
            </div>
        </div>
    );
};

export default MobileRemoteControlInfo;
